import { configureStore } from '@reduxjs/toolkit';
import authReducer from './Slices/authSlice';
import busReducer from './Slices/busSlice';
import serviceReducer from './Slices/servicesSlice'
import busRoutesReducer from './Slices/busRoutesSlice'
import busStopsReducer from './Slices/busStopsSlice'
import busOperatorsReducer from './Slices/busOperatorsSlice'
export const store = configureStore({
  reducer: {
    auth: authReducer,
    bus: busReducer,
    services:serviceReducer,
        busRoutes: busRoutesReducer,
    busStops: busStopsReducer, 
        busOperators: busOperatorsReducer,    

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});